import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Radio } from 'redpoints-front-components/index';
import { withContext } from 'redpoints-front-common/components';

import { facilitatorValidationSetSelectedFilterByCustomer } from '../../../actions/facilitatorValidationActions';
import {
  getFacilitatorValidationDomainsIsLoading,
  getFacilitatorValidationSelectedFilterByCustomer,
} from '../../../reducers/tasks/facilitatorValidation';
import { translate } from '../../../helpers/languageHelper';

const getTranslation = key =>
  translate(`tasks.facilitatorValidation.filters.filterByCustomer.${key}`);

const ALL_CUSTOMERS_LABEL = getTranslation('filterByAllCustomersLabel');
const CURRENT_CUSTOMER_LABEL = getTranslation('filterByCustomerLabel');

const FacilitatorValidationFiltersCustomer = ({
  customer,
  facilitatorValidationSetSelectedFilterByCustomer,
  isEnableFilterByTenant,
  isLoading,
  selectedCustomer,
}) => {
  const dataOptions = [
    {
      value: true,
      text: `${CURRENT_CUSTOMER_LABEL} (${customer.name})`,
    },
    {
      disabled: !isEnableFilterByTenant,
      value: false,
      text: `${ALL_CUSTOMERS_LABEL} (${customer.tenant.name})`,
    },
  ];

  const handleCustomerChange = ({ target }) => {
    facilitatorValidationSetSelectedFilterByCustomer({
      filterByCustomer: target.value,
    });
  };

  return (
    <Radio
      className="facilitator-validation-filter-by-customer"
      data={dataOptions}
      disabled={isLoading}
      label={getTranslation('label')}
      onChange={handleCustomerChange}
      value={selectedCustomer}
      vertical
    />
  );
};

const mapStateToProps = state => ({
  selectedCustomer: getFacilitatorValidationSelectedFilterByCustomer(state),
  isLoading: getFacilitatorValidationDomainsIsLoading(state),
});

export default compose(
  withContext,
  connect(mapStateToProps, {
    facilitatorValidationSetSelectedFilterByCustomer,
  })
)(FacilitatorValidationFiltersCustomer);
